import clientTag from './clientTag'
export default clientTag
